let shippingmodetypes = ["Sea", "Land", "Air"];
export default shippingmodetypes;
